import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import "../css/calculator.css";

const LOAN_OPTIONS = [
  { label: "Travel", icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M22 2L11 13"/><polygon points="22 2 15 22 11 13 2 9 22 2" fill="currentColor"/></svg> },
  { label: "Medical", icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg> },
  { label: "Wedding", icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg> },
  { label: "Gifting", icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg> },
  { label: "Education", icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/></svg> },
  { label: "Two-Wheeler", icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="5" cy="17" r="3"/><circle cx="19" cy="17" r="3"/><path d="M12 17V7l-4 5h4"/><path d="M9 7h4l3 5"/></svg> },
  { label: "Home", icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg> },
  { label: "Occasions", icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg> },
];

const Calculator = () => {
  const [amount, setAmount] = useState(30000);
  const [days, setDays] = useState(15);
  const [rate, setRate] = useState(0.25);

  const interest = (amount * rate * days) / 100;
  const totalPayment = amount + interest;
  const processingFeeAmt = Math.round(amount * 0.02);
  const amtPct = ((amount - 5000) / (100000 - 5000)) * 100;
  const daysPct = ((days - 1) / (60 - 1)) * 100;
  const ratePct = ((rate - 0.25) / (1 - 0.25)) * 100;

  return (
    <>
      <Helmet>
        <title>Loan Calculator — Salary Uncle</title>
        <meta name="description" content="Calculate your salary loan repayment instantly. Loans from ₹5,000 to ₹1,00,000. Transparent and accurate." />
      </Helmet>

      {/* HERO */}
      <section className="calc-hero">
        <div className="calc-hero-inner">
          <span className="calc-tag">LOAN CALCULATOR</span>
          <h1>Plan Your Loan <span className="calc-hero-green">With Confidence</span></h1>
          <p>Instant salary loans from ₹5,000 to ₹1,00,000. Calculate repayment in seconds — transparent and accurate.</p>
        </div>
      </section>

      {/* BODY */}
      <section className="calc-body">
        <div className="calc-body-inner">

          {/* ── LEFT: Calculator ── */}
          <div className="calc-left">
            {/* Calculator Card */}
            <div className="calc-card">
              {/* Header */}
              <div className="calc-card-header">
                <div className="calc-card-icon">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="2" width="16" height="20" rx="2"/><line x1="8" y1="6" x2="16" y2="6"/><line x1="8" y1="10" x2="16" y2="10"/><line x1="8" y1="14" x2="12" y2="14"/></svg>
                </div>
                <div>
                  <div className="calc-card-title">Loan Calculator</div>
                  <div className="calc-card-sub">Salary loans · Short-term</div>
                </div>
              </div>

              {/* Amount */}
              <div className="calc-field">
                <div className="calc-field-top">
                  <span className="calc-field-name">Loan Amount</span>
                  <span className="calc-field-badge">₹{amount.toLocaleString('en-IN')}</span>
                </div>
                <div className="calc-track-wrap">
                  <div className="calc-track-fill" style={{ width: `${amtPct}%` }} />
                  <input type="range" className="calc-slider" min="5000" max="100000" step="1000"
                    value={amount} onChange={e => setAmount(Number(e.target.value))} />
                </div>
                <div className="calc-range-labels"><span>₹5,000</span><span>₹1,00,000</span></div>
              </div>

              {/* Days */}
              <div className="calc-field">
                <div className="calc-field-top">
                  <span className="calc-field-name">Loan Period</span>
                  <span className="calc-field-badge">{days} Day{days > 1 ? 's' : ''}</span>
                </div>
                <div className="calc-track-wrap">
                  <div className="calc-track-fill" style={{ width: `${daysPct}%` }} />
                  <input type="range" className="calc-slider" min="1" max="60" step="1"
                    value={days} onChange={e => setDays(Number(e.target.value))} />
                </div>
                <div className="calc-range-labels"><span>1 Day</span><span>60 Days</span></div>
              </div>

              {/* Rate */}
              <div className="calc-field">
                <div className="calc-field-top">
                  <span className="calc-field-name">Interest Rate <span className="calc-field-hint">(per day)</span></span>
                  <span className="calc-field-badge">{rate.toFixed(2)}%</span>
                </div>
                <div className="calc-track-wrap">
                  <div className="calc-track-fill" style={{ width: `${ratePct}%` }} />
                  <input type="range" className="calc-slider" min="0.25" max="1" step="0.25"
                    value={rate} onChange={e => setRate(Number(e.target.value))} />
                </div>
                <div className="calc-range-labels"><span>0.25%</span><span>0.50%</span><span>0.75%</span><span>1%</span></div>
              </div>

              {/* Result Summary */}
              <div className="calc-summary">
                <div className="calc-summary-item">
                  <div className="calc-summary-label">Principal</div>
                  <div className="calc-summary-val">₹{amount.toLocaleString('en-IN')}</div>
                </div>
                <div className="calc-summary-sep" />
                <div className="calc-summary-item">
                  <div className="calc-summary-label">Interest</div>
                  <div className="calc-summary-val">₹{Math.round(interest).toLocaleString('en-IN')}</div>
                </div>
                <div className="calc-summary-sep" />
                <div className="calc-summary-item">
                  <div className="calc-summary-label">Processing Fee</div>
                  <div className="calc-summary-val">2%</div>
                </div>
              </div>

              <div className="calc-total-row">
                <span>Total Repayment</span>
                <span className="calc-total-amt">₹{Math.round(totalPayment + processingFeeAmt).toLocaleString('en-IN')}</span>
              </div>

              <Link to="/apply-now" className="calc-apply-btn">
                Apply Now
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
              </Link>
            </div>
          </div>

          {/* ── RIGHT: Options + Stats ── */}
          <div className="calc-right">

            {/* Loan Options */}
            <div className="calc-options-card">
              <div className="calc-options-header">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>
                <h3>Personal Loan Options</h3>
              </div>
              <div className="calc-options-grid">
                {LOAN_OPTIONS.map((o, i) => (
                  <div className="calc-option-item" key={i}>
                    <div className="calc-option-icon">{o.icon}</div>
                    <span className="calc-option-label">{o.label}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Stats */}
            <div className="calc-stats-row">
              {[
                { num: "15,000+", label: "Loans Approved", icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg> },
                { num: "10,000+", label: "Happy Users", icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg> },
                { num: "250+", label: "Finance Experts", icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#509540" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg> },
              ].map((s, i) => (
                <div className="calc-stat-card" key={i}>
                  <div className="calc-stat-icon">{s.icon}</div>
                  <div className="calc-stat-num">{s.num}</div>
                  <div className="calc-stat-label">{s.label}</div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default Calculator;
